import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "size", "mode", "aria-label", "aria-describedby", "type", "isFullWidth", "isDisabled", "isInvalid", "isReadOnly", "defaultValue", "minLength", "maxLength", "name", "placeholder", "value", "onChange", "onBlur", "onFocus", "leftElement", "rightElement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import cx from 'classnames';
import { ThemeProvider } from 'styled-components';
import { prefix } from '../../tools/settings';
import { Styled } from './TextInput.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TextInput = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      size = _ref.size,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      ariaLabel = _ref['aria-label'],
      ariaDescribedby = _ref['aria-describedby'],
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$isFullWidth = _ref.isFullWidth,
      isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      _ref$isReadOnly = _ref.isReadOnly,
      isReadOnly = _ref$isReadOnly === void 0 ? false : _ref$isReadOnly,
      defaultValue = _ref.defaultValue,
      minLength = _ref.minLength,
      maxLength = _ref.maxLength,
      name = _ref.name,
      placeholder = _ref.placeholder,
      value = _ref.value,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      leftElement = _ref.leftElement,
      rightElement = _ref.rightElement,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-text-input"), true), _defineProperty(_cx, "".concat(prefix, "-text-input--fullwidth"), isFullWidth), _defineProperty(_cx, "".concat(prefix, "-text-input--left-element"), leftElement), _defineProperty(_cx, "".concat(prefix, "-text-input--right-element"), rightElement), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsxs(Styled.TextInputGroup, {
      isFullWidth: isFullWidth,
      isDisabled: isDisabled,
      children: [leftElement && _jsx(Styled.TextInputLeftElement, {
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        children: leftElement
      }), _jsx(Styled.TextInput, _objectSpread({
        ref: ref,
        className: className,
        disabled: isDisabled,
        readOnly: isReadOnly,
        "aria-invalid": isInvalid,
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-readonly": isReadOnly,
        defaultValue: defaultValue,
        minLength: minLength,
        maxLength: maxLength,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        id: id,
        name: name,
        value: value,
        type: type
      }, rest)), rightElement && _jsx(Styled.TextInputRightElement, {
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        children: rightElement
      })]
    })
  });
});
TextInput.displayName = 'TextInput';
export default TextInput;